import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class WorkDeliveryNormApi extends NewviewOaBaseApi { 
    
    public get ControllerName(): any {
        return 'work-delivery-norm'
    }
}